import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import GoogleAutocompleteHelper from '../../helpers/google_helper';
import ValidatedText from './validated_text_input';
import { isSelenium } from '../../helpers/application_helper';
import LocationHelper from '../../helpers/location_helper';

const MaterialAddressAutocomplete = ({ name, zip, value, large, onChange, onAutocompleteSelect, ...others }) => {
  const [input, setInput] = useState(null);
  const [setupAutoComplete, setSetupAutoComplete] = useState(false);
  const [autocompleteInfo, setAutocompleteInfo] = useState(null);

  useEffect(() => {
    if (!isSelenium() || LocationHelper.searchAsObj()?.autocomplete) {
      setSetupAutoComplete(true);
    }
  }, []);

  useEffect(() => {
    if (setupAutoComplete && input) {
      setSetupAutoComplete(false);
      GoogleAutocompleteHelper.install_autocomplete(
        ReactDOM.findDOMNode(input),
        zip,
        (streetAddress, zip, city, state) => {
          // required because this listener is only set up once, so any functions here do not update on rerenders
          setAutocompleteInfo({ streetAddress, zip, city, state });
          input.value = streetAddress;
        }
      );
      return () => GoogleAutocompleteHelper.uninstall_autocomplete();
    }
  }, [setupAutoComplete, input, onChange, onAutocompleteSelect, name, zip]);

  useEffect(() => {
    if (autocompleteInfo) {
      const { streetAddress, zip, city, state } = autocompleteInfo;
      // console.log('autocompleteInfo', autocompleteInfo);
      onChange?.(input, name, streetAddress);
      onAutocompleteSelect?.(streetAddress, zip, city, state);
      setAutocompleteInfo(false);
    }
  }, [autocompleteInfo, onChange, onAutocompleteSelect, input, name]);

  return (
    <ValidatedText
      {...{ name, value }}
      label={'Street'}
      variant={!large ? 'outlined' : undefined}
      color={'primary'}
      className={!large ? 'input-field' : undefined}
      inputRef={(input) => setInput(input)}
      type="text"
      style={{ width: '100%' }}
      margin={!large ? 'dense' : undefined}
      size={!large ? 'small' : undefined}
      {...others}
      defaultValue={value}
      onChange={(e) => onChange(e, e.currentTarget.name, e.currentTarget.value)}
    />
  );
};

MaterialAddressAutocomplete.propTypes = {
  zip: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
  onSubmit: PropTypes.func,
  onAutocompleteSelect: PropTypes.func,
  name: PropTypes.string,
  large: PropTypes.bool,
};

export default MaterialAddressAutocomplete;
